import { BaseFetch } from "../main-model"
export default class SubCriterionModel extends BaseFetch {
  getSubCriterionBy = (data) =>
    this.authFetch({
      url: "sub-criterion/getSubCriterionBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getSubCriterionById = (data) =>
    this.authFetch({
      url: "sub-criterion/getSubCriterionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSubCriterionById = (data) =>
    this.authFetch({
      url: "sub-criterion/updateSubCriterionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSubCriterion = (data) =>
    this.authFetch({
      url: "sub-criterion/insertSubCriterion",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSubCriterionById = (data) =>
    this.authFetch({
      url: "sub-criterion/deleteSubCriterionById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
